import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import {  qualitySchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";


const AddQuality = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    qualityName: editData?.qualityName,
    qualityLink: editData?.qualityLink || "",
    rawMaterial: editData?.rawMaterial || "",
    harvest: editData?.harvest || "",
    sorting: editData?.sorting || "",
    cuppingScore: editData?.cuppingScore || "",
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? false,
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: qualitySchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(
              `/quality/updateQuality/${editingId}`,
              values,
            )
          : await axiosInstance.post("/quality/createQuality", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/quality");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Quality", path: "/quality" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Quality
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label
                        htmlFor="quality-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="quality-sortOrder"
                        name="sortOrder"
                        placeholder="Enter  Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="form-group">
                      <label htmlFor="qualityName" className="col-form-label ">
                        Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="qualityName"
                        name="qualityName"
                        placeholder="Enter Quality name"
                        value={values.qualityName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.qualityName && errors.qualityName && (
                        <small className="text-danger">
                          {errors.qualityName}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="form-group">
                      <label htmlFor="qualityLink" className="col-form-label ">
                        Link
                      </label>
                      <input
                        type="text"
                        className="form-control border border-dark"
                        id="qualityLink"
                        name="qualityLink"
                        placeholder="Enter Quality link"
                        value={values.qualityLink}
                        onChange={handleChange}
                      />
                      {touched.qualityLink && errors.qualityLink && (
                        <small className="text-danger">
                          {errors.qualityLink}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="form-group">
                      <label htmlFor="rawMaterial" className="col-form-label ">
                        Raw Material
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="rawMaterial"
                        name="rawMaterial"
                        placeholder="Enter Raw Material"
                        value={values.rawMaterial || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.rawMaterial && errors.rawMaterial && (
                        <small className="text-danger">
                          {errors.rawMaterial}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="harvest" className="col-form-label ">
                        Harvest
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="harvest"
                        name="harvest"
                        placeholder="Enter Harvest"
                        value={values.harvest || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.harvest && errors.harvest && (
                        <small className="text-danger">{errors.harvest}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="sorting" className="col-form-label ">
                        Sorting
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="sorting"
                        name="sorting"
                        placeholder="Enter Sorting"
                        value={values.sorting || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.sorting && errors.sorting && (
                        <small className="text-danger">{errors.sorting}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="cuppingScore" className="col-form-label ">
                        Cupping Score
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="cuppingScore"
                        name="cuppingScore"
                        placeholder="Enter Cupping Score"
                        value={values.cuppingScore || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.cuppingScore && errors.cuppingScore && (
                        <small className="text-danger">
                          {errors.cuppingScore}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/quality">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddQuality;
